import { GET_LIST_FILE_TAGS, GET_LIST_FILE_TAGS_ERROR, GET_LIST_FILE_TAGS_SUCCESS } from './actionTypes';

export const getFileTags = (payload) => {
  return {
    payload,
    type: GET_LIST_FILE_TAGS,
  };
};
export const getFileTagsSuccess = ({ data, pagination }) => {
  return {
    payload: { data, pagination },
    type: GET_LIST_FILE_TAGS_SUCCESS,
  };
};
export const getFileTagsError = ({ message }) => {
  return {
    payload: { message },
    type: GET_LIST_FILE_TAGS_ERROR,
  };
};